import { UnreachableFunction } from 'ui/base/types';
import { Theme, ThemedStyles } from 'ui/base/theme';

import { DeviceType } from 'services/pangolin/types';
import { HostDeviceType } from 'services/pangolin/protos/hosts_pb';

import baseStyles from './device_types.module.css';

import deviceTypeIconImageMiscDaylight from './device_types_icons/misc/light.png';
import deviceTypeIconImageMiscMidnight from './device_types_icons/misc/dark.png';
import deviceTypeIconImageDesktopDaylight from './device_types_icons/desktop/light.png';
import deviceTypeIconImageDesktopMidnight from './device_types_icons/desktop/dark.png';
import deviceTypeIconImageCameraDaylight from './device_types_icons/camera/light.png';
import deviceTypeIconImageCameraMidnight from './device_types_icons/camera/dark.png';
import deviceTypeIconImageGamingDaylight from './device_types_icons/gaming/light.png';
import deviceTypeIconImageGamingMidnight from './device_types_icons/gaming/dark.png';
import deviceTypeIconImageMediaDaylight from './device_types_icons/media/light.png';
import deviceTypeIconImageMediaMidnight from './device_types_icons/media/dark.png';
import deviceTypeIconImageMobileDaylight from './device_types_icons/mobile/light.png';
import deviceTypeIconImageMobileMidnight from './device_types_icons/mobile/dark.png';
import deviceTypeIconImageNetworkDaylight from './device_types_icons/network/light.png';
import deviceTypeIconImageNetworkMidnight from './device_types_icons/network/dark.png';
import deviceTypeIconImagePrinterDaylight from './device_types_icons/printer/light.png';
import deviceTypeIconImagePrinterMidnight from './device_types_icons/printer/dark.png';
import deviceTypeIconImageVpnDaylight from './device_types_icons/vpn/light.png';
import deviceTypeIconImageVpnMidnight from './device_types_icons/vpn/dark.png';

export type DeviceTypeIconStyles = {
  desktop: string;
  misc: string;
  camera: string;
  gaming: string;
  media: string;
  mobile: string;
  network: string;
  printer: string;
  vpn: string;
};

export const themedDeviceTypeIconClassStyles: ThemedStyles<DeviceTypeIconStyles> = {
  [Theme.DAYLIGHT]: {
    desktop: baseStyles.deviceTypeIconClassDesktopDaylight,
    misc: baseStyles.deviceTypeIconClassMiscDaylight,
    camera: baseStyles.deviceTypeIconClassCameraDaylight,
    gaming: baseStyles.deviceTypeIconClassGamingDaylight,
    media: baseStyles.deviceTypeIconClassMediaDaylight,
    mobile: baseStyles.deviceTypeIconClassMobileDaylight,
    network: baseStyles.deviceTypeIconClassNetworkDaylight,
    printer: baseStyles.deviceTypeIconClassPrinterDaylight,
    vpn: baseStyles.deviceTypeIconClassVPNDaylight,
  },
  [Theme.MIDNIGHT]: {
    desktop: baseStyles.deviceTypeIconClassDesktopMidnight,
    misc: baseStyles.deviceTypeIconClassMiscMidnight,
    camera: baseStyles.deviceTypeIconClassCameraMidnight,
    gaming: baseStyles.deviceTypeIconClassGamingMidnight,
    media: baseStyles.deviceTypeIconClassMediaMidnight,
    mobile: baseStyles.deviceTypeIconClassMobileMidnight,
    network: baseStyles.deviceTypeIconClassNetworkMidnight,
    printer: baseStyles.deviceTypeIconClassPrinterMidnight,
    vpn: baseStyles.deviceTypeIconClassVPNMidnight,
  },
};

export const themedDeviceTypeIconImageStyles: ThemedStyles<DeviceTypeIconStyles> = {
  [Theme.DAYLIGHT]: {
    desktop: deviceTypeIconImageDesktopDaylight,
    misc: deviceTypeIconImageMiscDaylight,
    camera: deviceTypeIconImageCameraDaylight,
    gaming: deviceTypeIconImageGamingDaylight,
    media: deviceTypeIconImageMediaDaylight,
    mobile: deviceTypeIconImageMobileDaylight,
    network: deviceTypeIconImageNetworkDaylight,
    printer: deviceTypeIconImagePrinterDaylight,
    vpn: deviceTypeIconImageVpnDaylight,
  },
  [Theme.MIDNIGHT]: {
    desktop: deviceTypeIconImageDesktopMidnight,
    misc: deviceTypeIconImageMiscMidnight,
    camera: deviceTypeIconImageCameraMidnight,
    gaming: deviceTypeIconImageGamingMidnight,
    media: deviceTypeIconImageMediaMidnight,
    mobile: deviceTypeIconImageMobileMidnight,
    network: deviceTypeIconImageNetworkMidnight,
    printer: deviceTypeIconImagePrinterMidnight,
    vpn: deviceTypeIconImageVpnMidnight,
  },
};

export const getDeviceTypeIcon = (styles: DeviceTypeIconStyles, type: DeviceType): string => {
  switch(type) {
    case HostDeviceType.H_UNKNOWN:
      return styles.misc;
    case HostDeviceType.H_DESKTOP:
      return styles.desktop;
    case HostDeviceType.H_MISC:
      return styles.misc;
    case HostDeviceType.H_CAMERA:
      return styles.camera;
    case HostDeviceType.H_GAMING:
      return styles.gaming;
    case HostDeviceType.H_MEDIA:
      return styles.media;
    case HostDeviceType.H_MOBILE:
      return styles.mobile;
    case HostDeviceType.H_NETWORK:
      return styles.network;
    case HostDeviceType.H_PRINTER:
      return styles.printer;
    case HostDeviceType.H_VPN:
      return styles.vpn;
    default:
      return UnreachableFunction(type);
  }
};
